import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    padding: 0 16px;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding: 0 38px;
    }
  }
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`
